import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';

import { PositionDto } from './position.dto.schema';

export class PositionMapper {
  static dtoToEntity(dto: PositionDto): PositionGeocode {
    return {
      coordinates: convertCoordinates(dto.coordinates || []),
      properties: {
        name: dto.properties.name,
        address: dto.properties.address,
        city: dto.properties.city || '',
        countryCode: dto.properties.countryCode || '',
      },
    };
  }

  static entityToDto(entity: PositionGeocode): PositionDto {
    return {
      coordinates: entity.coordinates,
      properties: {
        name: entity.properties.name,
        address: entity.properties.address,
        city: entity.properties.city,
        countryCode: entity.properties.countryCode,
      },
    };
  }
}

function convertCoordinates(coordinates: number[]): [number, number] {
  const [longitude, latitude] = coordinates;
  if (typeof longitude !== 'number' || typeof latitude !== 'number') {
    return [0, 0];
  }
  return [longitude, latitude];
}
